import React, { FC } from 'react';
import { Provider } from 'react-redux';
import { AUPortal, LangContext } from '@aarhus-university/au-lib-react-components/src/lib/context';
import LoginWrapperComponent from '../components/login-menu/LoginWrapperComponent';
import MenuWrapperComponent from '../components/login-menu/MenuWrapperComponent';
import SystemMessagesWrapperComponent from '../components/system-messages/SystemMessagesWrapperComponent';
import { setupStore } from '../store/configureStore';
import systemIds from '../lib/systemIds';

const store = setupStore();

const AppWrapperComponent: FC = () => (
  <AUPortal.Provider name="mitstudie">
    <LangContext.Provider value={window.appLang}>
      <Provider store={store}>
        <SystemMessagesWrapperComponent systemId={systemIds.mitStudieForside} />
        <LoginWrapperComponent />
        <MenuWrapperComponent />
      </Provider>
    </LangContext.Provider>
  </AUPortal.Provider>
);

AppWrapperComponent.displayName = 'AppWrapperComponent';
export default AppWrapperComponent;
